var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "200px",
    height: "300px",
    viewBox: "0 0 200 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\n        Artboard\n    ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n        Created with Sketch.\n    ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 200,
    height: 300,
    x: 0,
    y: 0,
    fill: "#151819"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(28.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 72.5,
    cy: 72.5,
    r: 72.5,
    fill: "#181818",
    stroke: "#2B2B2B",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 73,
    cy: 74,
    r: 30,
    fill: "#131313"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(77.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 23,
    cy: 23,
    r: 23,
    fill: "#181818",
    stroke: "#2B2B2B",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-2",
    cx: 23,
    cy: 23,
    r: 10,
    fill: "#131313"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/Speaker.d9c87bc0.svg";
export { ForwardRef as ReactComponent };